import React from "react";
import { ArrowRight, TrendingUp, CircleCheck, Target } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const caseStudies = [{
  id: 1,
  title: "Identité de Marque - Leader Agro-Industriel",
  category: "Branding & Stratégie",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/diverse_corporate_branding_team.png",
  problem: "Absence d'une image de marque cohérente pour l'exportation des produits locaux vers le marché sous-régional.",
  solution: "Refonte complète de l'identité visuelle et création d'un guide de style institutionnel rigoureux.",
  result1: "Cohérence 100%",
  result2: "Notoriété +30%",
  result3: "Standard International",
  link: "/ProjectsPage"
}, {
  id: 2,
  title: "Sommet International de l'Énergie",
  category: "Événementiel Professionnel",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/international_summit_african_delegates.png",
  problem: "Besoin de coordonner un événement de haut niveau accueillant des délégations ministérielles africaines.",
  solution: "Production exécutive complète : scénographie, logistique VIP et gestion de la communication de crise.",
  result1: "12 Délégations",
  result2: "Impact Média Global",
  result3: "Excellence Opérationnelle",
  link: "/ProjectsPage"
}, {
  id: 3,
  title: "Transformation Digitale - Groupe BTP",
  category: "Communication Digitale",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/multicultural_digital_office_btp.png",
  problem: "Processus de recrutement et visibilité institutionnelle limités par une présence digitale obsolète.",
  solution: "Déploiement d'une stratégie de contenus B2B et optimisation de l'écosystème social média.",
  result1: "Engagement +200%",
  result2: "Talents Attirés",
  result3: "Image Innovante",
  link: "/ProjectsPage"
}, {
  id: 4,
  title: "Campagne de Sensibilisation - Impact Social",
  category: "Communication Stratégique",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/community_outreach_health_campaign.png",
  problem: "Nécessité de vulgariser des enjeux complexes de santé publique auprès des populations rurales.",
  solution: "Conception d'une campagne multilingue alliant supports visuels de proximité et relais communautaires.",
  result1: "2M+ Portée",
  result2: "Adhésion Locale",
  result3: "Objectifs Atteints",
  link: "/ProjectsPage"
}];
export default function EtudesDeCas() {
  return <section data-section-id="49740" id="portfolio-de-lagence" className="py-24 relative overflow-hidden !bg-[hsl(240,5%,96%)] !text-[hsl(210,17%,98%)] lg:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 to-background pointer-events-none" />

      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6 font-serif">
            Réalisations & Impact
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
            Une démonstration concrète de notre savoir-faire stratégique. Découvrez comment Freelance Com & Event transforme des défis complexes en réussites mesurables pour des organisations exigeantes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {caseStudies.map((study, i) => <div key={study.id} data-index={i} className="group flex flex-col bg-card rounded-sm overflow-hidden border border-border/40 shadow-xl hover:shadow-2xl transition-all duration-500 backdrop-blur-xl">
              {}
              <div className="relative aspect-[16/10] overflow-hidden bg-muted">
                <img src={study.image} alt={study.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 filter grayscale-[40%] group-hover:grayscale-0" />
                
                {}
                <div className="absolute inset-0 bg-primary/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-sm">
                  <Button asChild size="lg" className="rounded-sm px-8 shadow-2xl translate-y-4 group-hover:translate-y-0 transition-transform duration-300 bg-primary text-primary-foreground font-sans font-bold">
                    <Link to={study.link}>
                      Voir l'étude de cas <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </div>

                {}
                <div className="absolute top-4 left-4">
                  <Badge variant="secondary" className="bg-background/95 backdrop-blur-md text-foreground shadow-sm border-border/50 font-mono text-[10px] uppercase tracking-widest rounded-sm">
                    {study.category}
                  </Badge>
                </div>
              </div>

              {}
              <div className="flex flex-col flex-grow p-8 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors font-serif tracking-tight">
                    {study.title}
                  </h3>
                  <div className="h-1 w-16 bg-secondary rounded-full mt-4" />
                </div>

                {}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-sm">
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-muted-foreground font-mono font-medium uppercase tracking-wider text-[10px]">
                      <Target className="h-3 w-3 text-secondary" /> Challenge
                    </div>
                    <p className="text-muted-foreground leading-relaxed font-sans">
                      {study.problem}
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-secondary font-mono font-medium uppercase tracking-wider text-[10px]">
                      <CircleCheck className="h-3 w-3" /> Solution
                    </div>
                    <p className="text-muted-foreground leading-relaxed font-sans">
                      {study.solution}
                    </p>
                  </div>
                </div>

                {}
                <div className="mt-auto pt-6 border-t border-border/50">
                  <div className="flex items-center gap-2 mb-3 text-[10px] font-mono font-medium text-muted-foreground uppercase tracking-widest">
                    <TrendingUp className="h-3 w-3 text-secondary" /> Indicateurs de Succès
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {[study.result1, study.result2, study.result3].map((result, idx) => <Badge key={idx} data-index={idx} variant="outline" className="bg-secondary/10 border-secondary/20 text-foreground px-3 py-1 font-sans text-xs rounded-sm">
                        {result}
                      </Badge>)}
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild variant="outline" size="lg" className="border-primary/40 hover:bg-primary/10 text-foreground font-sans rounded-sm transition-all duration-300">
            <Link to="/ProjectsPage">
              Consulter tout notre portfolio
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}